import React, { FC, Suspense } from 'react';
import ContentLoader from 'react-content-loader';
import { T } from 'src/shared/helpers';
import theme from 'src/shared/theme';
import { ContainerSmall } from '../../containers';
import SelectedOptionValue from '../../state/selectedOptionValue';
import { variantsQuery$data } from './__generated__/variantsQuery.graphql';
import OptionsList from './addVariantOptionsList';
import { Link } from '../../../../widgets/buttons';
import { NotificationBanner } from '../../../../widgets/notificationBanner';
import { PageHeader } from '../../../../widgets/pageHeader';
import { ContainerBase } from '../../../../widgets/layouts';
import styled from 'styled-components';
import { MerchantProductVariantImageMatch } from './helpers';

const OptionsLoader = (
    <ContainerSmall>
        <ContentLoader speed={2} width='100%' height='400px' backgroundColor={theme.skeleton.backgroundColor} foregroundColor={theme.skeleton.foregroundColor}>
            <rect x='0' y={0} width='150px' height='65' />
            <rect x='10px' y='95px' width='100px' height='21' rx='10' ry='10' />

            {new Array(3).fill(0).map((x, idx) => (
                <rect key={idx} x='0' y={145 + idx * 73.2} rx='10' ry='10' width='100%' height='53.2' />
            ))}
        </ContentLoader>
    </ContainerSmall>
);

interface AddVariantsProps {
    onAddVariantClick: (selectedOptionsValues: SelectedOptionValue[], merchantProductVariantImageMatches: MerchantProductVariantImageMatch[] | null) => void;
    onCancelClick: () => void;
    options: variantsQuery$data['merchantProductOptions'];
    //showBanner: boolean; lascio commentato, se è true serve per mostrare l'info banner solo se non sono ancora state importate varianti.
    importImageVariantForSalesChannel: boolean;
}

const PageHeaderContainer = styled.div`
    margin: 20px 0px !important;

    > div {
        padding-bottom: 0px !important;
    }
`;

const AddVariant: FC<AddVariantsProps> = ({ onAddVariantClick, onCancelClick, options, importImageVariantForSalesChannel }) => {
    const bannerContent = importImageVariantForSalesChannel ? (
        <>
            This is where you can bring your product attributes from the store into the Customizer, making them available to your customers. Attributes you
            don’t import will still appear on the product page but won’t be shown in the Customizer — they’ll only be passed to the cart. <br />
            <strong>If you import all attributes and options, Zakeke will also import the corresponding variant images.</strong> Otherwise, the default product
            image is used and can be replaced manually.
        </>
    ) : (
        <>
            This is where you can bring your product attributes from the store into the Customizer, making them available to your customers. Attributes you
            don’t import will still appear on the product page but won’t be shown in the Customizer — they’ll only be passed to the cart. Variant images won’t
            be imported automatically; Zakeke will use the main product image by default, and you can replace them manually if needed.
        </>
    );

    return (
        <ContainerBase>
            <PageHeaderContainer>
                <PageHeader
                    isBackVisible={false}
                    title={T._('Variant Options', 'Admin')}
                    description={
                        // showBanner ? (
                        <>
                            <NotificationBanner title='' content={bannerContent} />
                            <br />
                        </>
                        //)
                        // : null
                    }
                    learnMoreLabel={'Learn more in our full guide'}
                    learnMoreUrl={'https://zakeke.zendesk.com/hc/en-us/articles/360015501299-Variants'}
                />
            </PageHeaderContainer>
            <Suspense fallback={OptionsLoader}>
                <OptionsList options={options} onAddVariantClick={onAddVariantClick} onCancelClick={onCancelClick} />
            </Suspense>
        </ContainerBase>
    );
};

export default AddVariant;
